import AssignmentIcon from '@mui/icons-material/Assignment';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { theme } from '@shared/theme';

interface ApproversListCardProps {
  data: string[];
  label: string;
}

function ApproversListCard(props: ApproversListCardProps) {
  const { data, label } = props;

  return (
    <Box
      sx={{
        background: '#e9f6fd',
        borderRadius: theme.spacing(1.5),
        padding: theme.spacing(1),
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1),
        position: 'relative',
        width: '45%',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        border: '2px solid #b3e0f7',
        [theme.breakpoints.down('md')]: {
          width: '100%',
          marginBottom: theme.spacing(1),
        },
      }}
    >
      <Box>
        <Typography
          sx={{
            fontWeight: 'bold',
            fontSize: 14,
            color: '#1e6f98',
          }}
        >
          {label}
        </Typography>
        <Box mt={1}>
          {data?.map((answer, index) => (
            <Typography
              key={index}
              sx={{
                'fontSize': 14,
                'color': theme.palette.text.primary,
                'marginLeft': 2,
                'position': 'relative',
                '&::before': {
                  content: '"•"',
                  position: 'absolute',
                  left: -12,
                  color: '#1e6f98',
                  fontSize: 16,
                },
              }}
            >
              {answer}
            </Typography>
          ))}
        </Box>
      </Box>
      <Box
        sx={{
          background: theme.palette.background.paper,
          borderRadius: '50%',
          width: 40,
          height: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          top: -12,
          right: -12,
          boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
        }}
      >
        <AssignmentIcon sx={{ color: '#1e6f98', fontSize: 22 }} />
      </Box>
    </Box>
  );
}

export default ApproversListCard;
